import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';
import { getSignupUserId } from '../signup-user';

@Component({
  selector: 'app-reg-driver-payout-return',
  templateUrl: './reg-driver-payout-return.component.html',
  styleUrls: ['./reg-driver-payout-return.component.scss']
})
export class RegDriverPayoutReturnComponent implements OnInit {
  globals = Globals;
  isLoadingResults = true;
  connectStatus: any = null;
  profileDetails: any = {};

  constructor(private service: HttpService, private router: Router) {}

  ngOnInit() {
    const merchantId = getSignupUserId();
    this.profileDetails = JSON.parse(localStorage.getItem('driverProfile') || '{}');
    if (!merchantId || !this.profileDetails.driverId) {
      this.service.showError('Please continue driver registration.', 'ERROR');
      this.router.navigate(['/registration/drivers/payout-setup']);
      return;
    }
    this.refreshStatus();
  }

  refreshStatus() {
    const merchantId = getSignupUserId();
    this.isLoadingResults = true;
    this.service.getRequest(this.globals.urls.signUp.noauth.driverConnectStatus, {
      merchantId,
      _id: merchantId,
      driverId: this.profileDetails.driverId
    }).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1 && res.data) {
          this.connectStatus = res.data;
          if (this.canProceed()) {
            try {
              localStorage.setItem('reg-driver-payout-submitted', '1');
            } catch (e) { /* ignore */ }
          }
        }
      },
      () => {
        this.isLoadingResults = false;
      }
    );
  }

  canProceed(): boolean {
    if (!this.connectStatus) {
      return false;
    }
    if (this.connectStatus.payoutReady) {
      return true;
    }
    return !!(this.connectStatus.detailsSubmitted
      && this.connectStatus.connectStatus !== 'restricted');
  }

  continueToPreview() {
    if (!this.canProceed()) {
      this.router.navigate(['/registration/drivers/payout-setup']);
      return;
    }
    this.router.navigate(['/registration/drivers/preview']);
  }

  backToSetup() {
    this.router.navigate(['/registration/drivers/payout-setup']);
  }

  resultTitle(): string {
    if (this.isLoadingResults) {
      return 'Checking payout status…';
    }
    if (!this.connectStatus || !this.connectStatus.hasConnectedAccount) {
      return 'Payout setup incomplete';
    }
    if (this.connectStatus.payoutReady) {
      return 'Payouts enabled';
    }
    if (this.connectStatus.connectStatus === 'restricted') {
      return 'Action required';
    }
    if (this.connectStatus.detailsSubmitted) {
      return 'Details submitted';
    }
    return 'Continue setup';
  }

  resultBody(): string {
    if (this.isLoadingResults) {
      return 'Please wait while we confirm status with Stripe.';
    }
    if (this.connectStatus && this.connectStatus.connectStatus === 'restricted') {
      return 'Stripe could not verify payout details yet. Continue setup to fix any issues.';
    }
    if (this.canProceed()) {
      return 'You can continue to preview. Stripe may still review the account in the background.';
    }
    return 'Please return to payout setup and complete all required fields on Stripe.';
  }
}
